import { FormControlLabel } from '@mui/material';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';
import { Box, Button, Checkbox, Typography } from 'hephaestus/web';
import type { ChangeEvent } from 'react';

type ValidateSecuritiesDialogBoxProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  bodyText: string;
  checkboxLabel?: string;
  onCheckboxChange?: (checked: boolean) => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm: () => void;
  isChecked?: boolean;
  disableCancelButton?: boolean;
};

export const ValidateSecuritiesDialogBox = ({
  open,
  onClose,
  title,
  bodyText,
  checkboxLabel,
  onCheckboxChange,
  confirmButtonText = 'OK',
  cancelButtonText = 'Cancel',
  onConfirm,
  isChecked = false,
  disableCancelButton = false,
}: ValidateSecuritiesDialogBoxProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    sx={{
      maxWidth: '512px',
      margin: 'auto',
      '& .MuiDialog-paper': {
        margin: '32px',
        width: '100%',
        maxWidth: '512px',
      },
      '& .MuiDialogTitle-root': {
        fontWeight: 600,
        fontSize: '24px',
      },
    }}
  >
    <DialogTitle data-testid='validate-securities-dialog-box-title'>
      {title}
    </DialogTitle>
    <DialogContent>
      <Typography
        variant='bodyLarge'
        data-testid='validate-securities-dialog-box-body-text'
        sx={{
          color: '#6A6F7B',
          fontWeight: 400,
          fontSize: '14px',
        }}
        dangerouslySetInnerHTML={{ __html: bodyText }}
      />
      {checkboxLabel && onCheckboxChange && (
        <FormControlLabel
          data-testid='validate-securities-dialog-box-checkbox'
          sx={{
            ml: 0,
            gap: 1,
            '& .MuiFormControlLabel-label': {
              fontWeight: 600,
              fontSize: '14px',
            },
          }}
          control={
            <Checkbox
              slotProps={{
                input: {
                  'data-testid':
                    'validate-securities-dialog-box-checkbox-input',
                },
              }}
              checked={isChecked}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                onCheckboxChange(e.target.checked)
              }
            />
          }
          label={checkboxLabel}
        />
      )}
    </DialogContent>
    <DialogFooter>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          gap: 1,
        }}
      >
        {!disableCancelButton && (
          <Button
            data-testid='validate-securities-dialog-box-cancel-button'
            variant='contained'
            onClick={onClose}
            color='secondary'
          >
            {cancelButtonText}
          </Button>
        )}
        <Button
          data-testid='validate-securities-dialog-box-confirm-button'
          variant='contained'
          onClick={onConfirm}
          disabled={!!checkboxLabel && !isChecked}
        >
          {confirmButtonText}
        </Button>
      </Box>
    </DialogFooter>
  </Dialog>
);
